import { render } from "./AnnotationVideoPlayer.vue?vue&type=template&id=3f79940f&scoped=true"
import script from "./AnnotationVideoPlayer.vue?vue&type=script&lang=js"
export * from "./AnnotationVideoPlayer.vue?vue&type=script&lang=js"

import "./AnnotationVideoPlayer.vue?vue&type=style&index=0&id=3f79940f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f79940f"]])

export default __exports__